<template>
  <div v-if="!item.hidden && item.children" class="menu-wrapper">

    <template v-if="shouldShowOnlyOneChild(item)">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown': !isNest}">
          <item v-if="onlyOneChild.meta" :icon="onlyOneChild.meta.icon || item.meta.icon"
            :title="generateTitle(onlyOneChild.meta.title)" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)">
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta.icon" :title="generateTitle(item.meta.title)" />
      </template>

      <template v-for="child in item.children">
        <template v-if="!child.hidden">
          <sidebar-item v-if="child.children && child.children.length > 0" :is-nest="true" :item="child" :key="child.path"
            :base-path="resolvePath(child.path)" class="nest-menu" />

          <app-link v-else :to="resolvePath(child.path)" :key="child.name">
            <el-menu-item :index="resolvePath(child.path)">
              <item v-if="child.meta" :icon="child.meta.icon" :title="generateTitle(child.meta.title)" />
            </el-menu-item>
          </app-link>
        </template>
      </template>
    </el-submenu>

  </div>
</template>
<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: {
    Item,
    AppLink
  },
  mixins: [FixiOSBug],
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  mounted() {
    if (this.item.children) {
      this.findOnlyOneShowingChild(this.item.children, this.item)
    }
  },
  methods: {
    shouldShowOnlyOneChild(item) {
      return (
        this.onlyOneChild &&
        this.onlyOneChild !== item &&
        this.onlyOneChild.children &&
        (!this.onlyOneChild.children || this.onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      )
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },
    generateTitle,
    findOnlyOneShowingChild(children, parent) {
      children.forEach(child => {
        if (!child.hidden) {
          this.onlyOneChild = child
        }
      })

      if (!this.onlyOneChild) {
        this.onlyOneChild = {
          ...parent,
          path: '',
          noShowingChildren: true
        }
      }
    }
  }
}
</script>

<style>
.el-dialog__title,
.el-dialog__body,
.el-form-item__label,
span,
.el-tabs__item,
.el-radio-group,
.el-radio,
.el-radio__label,
.el-cascader,
.el-tree,
.el-tree-node__label,
.el-checkbox__label,
.el-checkbox,
.el-checkbox-group,
.menu-wrapper,
.el-submenu,
.el-submenu__title,
.el-submenu__title span,
.el-submenu__title,
.el-menu--inline,
.el-menu--inline a,
.el-menu--inline .el-menu-item,
.el-menu-item span .el-menu-item span {
  font-size: inherit !important;
}
</style>
